import { render } from "./PagePieChart.vue?vue&type=template&id=58ea1348&scoped=true"
import script from "./PagePieChart.vue?vue&type=script&lang=js"
export * from "./PagePieChart.vue?vue&type=script&lang=js"

import "./PagePieChart.vue?vue&type=style&index=0&id=58ea1348&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ea1348"]])

export default __exports__